import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="duplicate"
export default class extends Controller {
  static targets = ["template", "destination"];

  connect() {
    //    this.handle();
  }

  handle() {
    this.destinationTarget.insertAdjacentHTML(
      "beforeend",
      this.templateTarget.innerHTML,
    );
  }
}
